import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50f7c8ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xing" }, "*", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("资料提供申请表补充")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xing" }, "*", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("用印、用证审批表补充")

import { 
  resourceApplyApi,//资料及用印提交
  resourceDetailApi,//资料及用印详情
} from "@/api/businessChange";
import type { FormInstance } from "ant-design-vue";
import {
  ref,
  withDefaults,
  reactive,
} from "vue";
import Image from "@/components/Image.vue";
import change from "@/composables/change"
import { NodeItem } from "@/types/procss";

export default /*#__PURE__*/_defineComponent({
  props: {
    BranchCompanyFlowId: { default: 0 },
    preData: { default: () => [] },
    reEdit: { type: Boolean, default: false },
    update: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { BranchCompanyFlowId: number, preData:NodeItem[], reEdit:boolean, update: boolean }


const IsEdit = ref<boolean>(false); //必传文件是否可编辑
const IsBcEdit = ref<boolean>(false); //补充文件是否可编辑 true可编辑
const IsGDRMSEdit = ref<boolean>(false); //股东是否可编辑 true可编辑
let PostFiles = reactive({
  PageFiles: [],
});

// 表单字段定义
const FormData = reactive({
  PageFiles:[],
  IsSupplement:false,
});

const formRef5 = ref<FormInstance>(); //选址表单
let form5 = reactive({
  PageFiles: [],
});

//上传附件
const IsFirstGDHEdit = ref<boolean>(false); //是否第一次上传股东会决议
const handleUpload = (file: File, index?: number,key?:string) => {
  if (!file) {
    if (isShowModel.value) {
      form5.PageFiles[index as number] = {};
    } else{
      key?PostFiles.PageFiles[index as number] = {}: FormData.PageFiles[index as number] = {}
    }
    
  } else {
    if (isShowModel.value) {
      form5.PageFiles[index as number] = {
        ...file,
        FileUrl: file.Url,
      };
    } else{
      if(!FormData.PageFiles[index] || !FormData.PageFiles[index].FileUrl){
        if(index == 2){//判断审批页面是否有删除标识
          IsFirstGDHEdit.value = true; //是否第一次提交
        }
      }
      let _file = Object.assign({}, file, { FileUrl: file.Url });
      FormData.PageFiles[index as number] = _file;
    }
  }
};
//关闭补充弹窗
const handleCancelComplete = () => {
  isShowModel.value = false;
};


//封装方法字段
const FormRef = ref()
const common = reactive({
  ApplyApi:resourceApplyApi,
  DetailApi:resourceDetailApi,
  FormData:FormData,
  nodeIdx:6,
  FormRef:FormRef,
  PostFiles:PostFiles,
  formRef5:formRef5,
  props:reactive(props),
  IsFirstEdit1:IsFirstGDHEdit,
  form5:form5,
  IsEdit:IsEdit,
  IsBcEdit:IsBcEdit,
  IsGDRMSEdit:IsGDRMSEdit,
})

const {
  edit,
  isShowModel,
  handleOk,
  winHeight,
  actionButtons,
} = change(common)

//补充资料
const submitComplete = () => {
  handleOk(true)
};


return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      style: _normalizeStyle({ minHeight: _unref(winHeight) + 'px' }),
      class: _normalizeClass(["bussiness-form-wrapper", !_unref(edit)? 'border-bottom mb24': '']),
      layout: "vertical",
      model: _unref(FormData),
      ref_key: "FormRef",
      ref: FormRef
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          name: ['PageFiles', 0, 'FileUrl'],
          label: "资料提供申请表",
          rules: [{ required: true, message: '请上传资料提供表' }]
        }, {
          default: _withCtx(() => [
            _createVNode(Image, {
              value: _unref(FormData).PageFiles[0] && _unref(FormData).PageFiles[0].FileUrl? _unref(FormData).PageFiles[0].FileUrl : '',
              "disable-close": !( IsEdit.value  && _unref(edit)),
              disable: !!__props.preData || !_unref(edit),
              onUpload: _cache[0] || (_cache[0] = (file) => handleUpload(file, 0)),
              "download-link": {
          filename: '资料提供申请表.docx',
          fileKey: '5021',
        },
              "file-type": '1011'
            }, null, 8, ["value", "disable-close", "disable", "download-link"])
          ]),
          _: 1
        }),
        ( _unref(PostFiles).PageFiles.length > 0 && _unref(PostFiles).PageFiles[0])
          ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 0,
              name: "PostFiles"
            }, {
              label: _withCtx(() => [
                _hoisted_1,
                _hoisted_2
              ]),
              default: _withCtx(() => [
                _createVNode(Image, {
                  value: 
          _unref(PostFiles).PageFiles && _unref(PostFiles).PageFiles.length > 0
            ? _unref(PostFiles).PageFiles[0].FileUrl
            : ''
        ,
                  "disable-close": !( IsBcEdit.value && _unref(edit)),
                  disable: !( IsBcEdit.value && _unref(edit)),
                  "file-type": '1012',
                  onUpload: _cache[1] || (_cache[1] = (file) => handleUpload(file, 0,'PostFiles'))
                }, null, 8, ["value", "disable-close", "disable"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form_item, {
          name: ['PageFiles', 1, 'FileUrl'],
          label: "用印、用证审批表",
          rules: [ { required: true, message: '请上传用印、用证审批表' },]
        }, {
          default: _withCtx(() => [
            _createVNode(Image, {
              value: _unref(FormData).PageFiles[1] && _unref(FormData).PageFiles[1].FileUrl? _unref(FormData).PageFiles[1].FileUrl : '',
              "disable-close": !( IsEdit.value  && _unref(edit)),
              disable: !!__props.preData || !_unref(edit),
              onUpload: _cache[2] || (_cache[2] = (file) => handleUpload(file, 1)),
              "download-link": {
          filename: '用印、用证审批表.docx',
          fileKey: '5022',
        },
              "file-type": '1111'
            }, null, 8, ["value", "disable-close", "disable", "download-link"])
          ]),
          _: 1
        }),
        ( _unref(PostFiles).PageFiles.length > 1 && _unref(PostFiles).PageFiles[1] )
          ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 1,
              name: ['PageFiles', 1, 'FileUrl']
            }, {
              label: _withCtx(() => [
                _hoisted_3,
                _hoisted_4
              ]),
              default: _withCtx(() => [
                _createVNode(Image, {
                  value: 
          _unref(PostFiles).PageFiles && _unref(PostFiles).PageFiles.length > 1
            ? _unref(PostFiles).PageFiles[1].FileUrl
            : ''
        ,
                  "disable-close": !( IsBcEdit.value && _unref(edit)),
                  disable: !( IsBcEdit.value && _unref(edit)),
                  "file-type": '1112',
                  onUpload: _cache[3] || (_cache[3] = (file) => handleUpload(file, 1,'PostFiles'))
                }, null, 8, ["value", "disable-close", "disable"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form_item, {
          name: ['PageFiles', 3, 'FileUrl'],
          label: "工商营业执照正本"
        }, {
          default: _withCtx(() => [
            _createVNode(Image, {
              value:  _unref(FormData).PageFiles[3] && _unref(FormData).PageFiles[3]?.FileUrl ,
              "disable-close": !(IsFirstGDHEdit.value || ( (IsGDRMSEdit.value || IsEdit.value) && _unref(edit))),
              disable: !!__props.preData || !(( (IsGDRMSEdit.value || IsEdit.value) && _unref(edit)) || _unref(actionButtons).includes('-3')),
              onUpload: _cache[4] || (_cache[4] = (file) => handleUpload(file, 3)),
              "file-type": '541'
            }, null, 8, ["value", "disable-close", "disable"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          name: ['PageFiles', 4, 'FileUrl'],
          label: "工商营业执照副本"
        }, {
          default: _withCtx(() => [
            _createVNode(Image, {
              value:  _unref(FormData).PageFiles[4] && _unref(FormData).PageFiles[4]?.FileUrl ,
              "disable-close": !(IsFirstGDHEdit.value || ( (IsGDRMSEdit.value || IsEdit.value) && _unref(edit))),
              disable: !!__props.preData || !(( (IsGDRMSEdit.value || IsEdit.value) && _unref(edit)) || _unref(actionButtons).includes('-3')),
              onUpload: _cache[5] || (_cache[5] = (file) => handleUpload(file, 4)),
              "file-type": '542'
            }, null, 8, ["value", "disable-close", "disable"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          name: ['PageFiles', 2, 'FileUrl'],
          label: "其他需协助的文件",
          style: {"margin-right":"0"}
        }, {
          default: _withCtx(() => [
            _createVNode(Image, {
              value:  _unref(FormData).PageFiles[2] && _unref(FormData).PageFiles[2]?.FileUrl ,
              "disable-close": !(IsFirstGDHEdit.value || ( (IsGDRMSEdit.value || IsEdit.value) && _unref(edit))),
              disable: !!__props.preData || !(( (IsGDRMSEdit.value || IsEdit.value) && _unref(edit)) || _unref(actionButtons).includes('-3')),
              onUpload: _cache[6] || (_cache[6] = (file) => handleUpload(file, 2)),
              "file-type": '1211'
            }, null, 8, ["value", "disable-close", "disable"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["style", "model", "class"]),
    _createVNode(_component_a_modal, {
      class: "modal-dialog",
      visible: _unref(isShowModel),
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_isRef(isShowModel) ? (isShowModel).value = $event : null)),
      title: "补充申请",
      onOk: submitComplete,
      onCancel: handleCancelComplete
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          class: "flex",
          layout: "vertical",
          model: _unref(form5),
          ref_key: "formRef5",
          ref: formRef5,
          colon: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              style: {"margin-right":"60px"},
              name: ['PageFiles', 0, 'FileUrl'],
              label: "资料提供表",
              rules: [{ required: true, message: '请上传资料提供表' }]
            }, {
              default: _withCtx(() => [
                _createVNode(Image, {
                  value: 
            _unref(form5).PageFiles && _unref(form5).PageFiles.length > 0
              ? _unref(form5).PageFiles[0].FileUrl
              : ''
          ,
                  "disable-close": false,
                  disable: false,
                  onUpload: _cache[7] || (_cache[7] = (file) => handleUpload(file, 0)),
                  "file-type": '1012'
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: ['PageFiles', 1, 'FileUrl'],
              label: "用印、用证审批表",
              rules: [{ required: true, message: '请上传用印、用证审批表' }]
            }, {
              default: _withCtx(() => [
                _createVNode(Image, {
                  value: 
            _unref(form5).PageFiles && _unref(form5).PageFiles.length > 1
              ? _unref(form5).PageFiles[1].FileUrl
              : ''
          ,
                  "disable-close": false,
                  disable: false,
                  onUpload: _cache[8] || (_cache[8] = (file) => handleUpload(file, 1)),
                  "file-type": '1112'
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})